import React from "react";
import "./DashboardSectionEmptyState.css";

const DashboardSectionEmptyState = ({
  icon,
  title,
  description,
  className = "",
}) => (
  <div
    className={`dashboard-section-empty${className ? ` ${className}` : ""}`}
    role="status"
  >
    <div className="dashboard-section-empty__icon-wrap" aria-hidden="true">
      <img src={icon} alt="" className="dashboard-section-empty__icon" />
    </div>
    <div className="dashboard-section-empty__copy">
      <p className="dashboard-section-empty__title">{title}</p>
      <p className="dashboard-section-empty__description">{description}</p>
    </div>
  </div>
);

export default DashboardSectionEmptyState;
